import { Errors } from "../../common/components/Errors";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { usePickerContext } from "../hooks/usePickerContext";
import { useValidator } from "../hooks/useValidator";
import { usePickerCore } from "../hooks/usePickerCore";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export function SeatsPickerValidator({ selectedAssurance }) {

    const { state } = usePickerContext();
    const { error } = useValidator();
    const { errorsMessages, onValidateSuccess, tickets, dates } = state;
    const { onSaveBooking } = usePickerCore();

    return (
        <section className={"PickerContainer-section SeatsPicker_section"}>
            {(!!error || errorsMessages.length > 0) && (
                <Errors messages={[error, ...errorsMessages]}/>
            )}
            <button
                className={"SeatsPicker-saveButton"}
                disabled={!!error}
                onClick={() => {
                    const buildTicketData = ticket => {
                        // console.log(dates)
                        // console.log(ticket)
                        const currentDate = dates.find(date => ticket.at === date.at && ticket.hour === Object.keys(date.hours)[Object.keys(date.hours).indexOf(ticket.hour)]);
                        // console.log(currentDate)
                        //console.log(Object.keys(currentDate.hours)[0])
                        //Si on est sur le widget multiPass, on force l'heure
                        // banane 0000 - : 
                        const currentHourValue = Object.keys(currentDate.hours)[Object.keys(currentDate.hours).indexOf(ticket.hour)]
                        //const currentHourValue = state.typeWidget === 'FREE' ? Object.keys(currentDate.hours).find(value => currentDate.hours[value].current) : '0000'
                        const currentHour = currentDate.hours[currentHourValue];

                        if (state.typeWidget === 'FREE' && currentHourValue !== ticket.hour){
                            return null;
                        } 
                        const formulaCode = ticket.formulaCode
                            ? ticket.formulaCode
                            : currentHour.widget.pricing.find(price => price.categoryId === ticket.categoryId).formulaCode
                        const pricing = currentHour.widget.pricing.find(price => price.formulaCode === formulaCode && price.categoryId === ticket.categoryId)
                        let keyAssur = null
                        if (selectedAssurance) {
                            keyAssur = selectedAssurance.key;
                        }
                        // console.warn('ticket', ticket)
                        return ({
                            ...ticket,
                            formulaCode,
                            hour: currentHourValue,
                            roomId: currentHour.roomId,
                            serviceCode: pricing.serviceCode,
                            assuranceFormule: keyAssur
                        })
                    }
                    const data = tickets.map(buildTicketData).filter(ticket => !!ticket);
                    console.log(data)
                    if (!onValidateSuccess) {
                        onSaveBooking(data)
                    } else {
                        onValidateSuccess(data)
                    }
                }}
            >
                <span style={{ marginRight: '10px' }}>{state.translations.PLC_VALIDATE_BOOKING}</span>
                <FontAwesomeIcon icon={faShoppingCart}/>
            </button>
        </section>
    )
}